export default __webpack_public_path__ + "static/media/DivyaSharma_AppDevelopmentLead.9665aec4.jpg";